<template>
  <div class="extension">
    <div class="top-page-all">
      <div>我的客户列表</div>
    </div>
    <div class="top-bg-st">
      <div class="top-bg-ss">
        <img class="top-bg-ss-text" src="//qn.xwyyjt.com/ht_index_text.png" alt />
        <img class="top-bg-ss-bg" src="//qn.xwyyjt.com/ht_log_bo.png" alt />
      </div>
    </div>



     <div class="search-clr-box">
      <input v-model="userPhone" placeholder="输入手机号搜索用户" type="text" />
      <img
        @click="searchUser"
        class="search-icon"
        src="https://qn.xwyyjt.com/ht_xw_search_icon.png"
        alt
      />
    </div>
    <!--<template v-if="userType==3">-->
      <!--<div class="bottom-top-box">-->
        <!--<div>客户列表</div>-->
      <!--</div>-->

      <!--<div-->
        <!--v-if="list && list.length > 0"-->
        <!--class="list-box"-->
        <!--v-bottom-load="{handle: getList, distance: 30}"-->
      <!--&gt;-->
        <!--<template>-->
          <!--<div class="list-item-d" v-for="(item,index) in list">-->
            <!--<div class="list-item-left">-->
              <!--<div class="item-top">{{item.realname}}({{item.phone}})</div>-->
              <!--<div class="item-bottom">状态 : {{ item.status | statusMap }}</div>-->
              <!--<div class="item-bottom">生日 : {{item.year}}-{{item.month}}</div>-->
              <!--<div class="item-bottom">性别 : {{item.sex == 1?'男':'女'}}</div>-->
              <!--<div class="item-bottom">职业 : {{item.occup}}</div>-->
              <!--<div class="item-bottom">审批管理员 : {{item.admin}}</div>-->
              <!--<div class="item-bottom">拒绝理由 : {{item.reason}}</div>-->
              <!--<div class="item-bottom">客户介绍 : {{item.simple}}</div>-->
              <!--<div class="item-bottom">创建时间 : {{timeFormat(item.create_time)}}</div>-->
            <!--</div>-->
            <!--<div style="display: flex;border-top: 1px solid #eee;margin-top:.12rem">-->
              <!--<div-->
               <!--@click.stop="goDetailReturn(item)"-->
                <!--style="flex:1;text-align:center;padding-right: .2rem;height: .7rem;line-height: .7rem;padding-left: .05rem;font-size: .16rem;color: #999;"-->
              <!--&gt; 查看详情 </div>-->
              <!--<div-->
               <!--@click.stop="editUserInfo(item)"-->
                <!--style="flex:1;text-align:center;padding-right: .1rem;height: .7rem;line-height: .7rem;padding-left: .2rem;border-left: 1px solid #eee;font-size: .16rem"-->
              <!--&gt;用户信息修改</div>-->
            <!--</div>-->
          <!--</div>-->
          <!--<div class="load-more">-->
            <!--<span v-show="endMark">没有数据了～～～</span>-->
          <!--</div>-->
        <!--</template>-->
      <!--</div>-->
    <!--</template>-->

    <!--<template v-else>-->

      <div class="bottom-top-box">
        <div>我的客户列表</div>
        <div @click="goDetail">添加客户＞</div>
      </div>

      <div
        v-if="list && list.length > 0"
        class="list-box"
        v-bottom-load="{handle: getList, distance: 30}"
      >
        <template>
          <div @click="goDetail(item)" class="list-item" v-for="(item,index) in list">
            <div class="list-item-left">
              <div class="item-top">{{item.realname}}({{item.phone}})</div>
              <div class="item-bottom">创建时间 : {{timeFormat(item.create_time)}}</div>
            </div>
            <div style="display: flex;">
              <div
                @click.stop="getHy(item)"
                style="padding-right: .2rem;height: 1rem;line-height: 1rem;padding-left: .05rem;font-size: .16rem;color: #999;"
              >申请会员</div>
              <div
                style="padding-right: .1rem;height: 1rem;line-height: 1rem;padding-left: .2rem;border-left: 1px solid #eee;font-size: .16rem"
              >授权书影币</div>
            </div>
          </div>
          <div class="load-more">
            <span v-show="endMark">没有数据了～～～</span>
          </div>
        </template>
      </div>
    <!--</template>-->
  </div>
</template>

<script>
export default {
  name: "extension",
  data() {
    return {
      userType: "",
      show: false,
      list: [],
      loading: false,
      finished: false,
      endMark: false, //是否最后
      endLoad: false,
      userPhone: "",
      page: 0,
      isEnd: false,
      key: true,
    };
  },
  filters: {
    // 状态-1报名已拒绝 0待分配 客服 1客服待跟进 2 1审通过 3 2审通过 4 3审通过
    statusMap(state) {
      if (state == -1) {
        return "报名已拒绝";
      }
       if (state == 1) {
        return "客服待跟进";
      }
       if (state == 2) {
        return "审通过";
      }
       if (state == 0) {
        return "待分配客服";
      }
    },
  },
  mounted() {
    // let userType = localStorage.getItem("type");
    // this.userType = +userType;
    // if (userType == 3) {
    //   this.getHuawu();
    // } else {
      this.getList();
    // }
  },
  methods: {
    getHuawu() {
      if (!this.key || this.isEnd) return;
      this.key = false;
      this.$http
        .post("huawu", {
          token: window.localStorage.getItem("token"),
          limit: 10,
          page: this.page,
        })
        .then(
          (res) => {
            this.key = true;
            if (res.data.code === 200) {
              let resData = res.data;
              this.list = [...this.list, ...resData.data.data];
              this.page++;
              this.isEnd = this.page * 10 >= +resData.data.total;
            } else {
              this.$toast(res.data.msg || "系统错误");
            }
          },
          (e) => {
            this.key = true;
            this.$toast("网络错误");
          }
        );
    },
    editUserInfo(item) {
      if (item) {
        this.$router.push({
          path: "/returnDetail",
          query: {
            item: JSON.stringify(item) , //对象转为字符串
          },
        });
      }
    },
    goDetailReturn(item) {
    if (item) {
        this.$router.push({
          path: "/returnView",
          query: {
            item: JSON.stringify(item) , //对象转为字符串
          },
        });
      }
    },
    goDetailUser() {

    },
    getHy(item) {
      this.$router.push({
        path: "/applyHy",
        query: {
          mid: item.mid, //对象转为字符串
        },
      });
    },
    searchUser() {
      if (!this.userPhone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.userPhone)) {
        this.$toast("请输入正确的手机号");
        return;
      }
      this.$http
        .post("userphone", {
          phone: this.userPhone.trim(),
        })
        .then(
          (res) => {
            if (res.data.code === 200) {
              let data = res.data.data;
              this.$router.push({
                path: "/detail",
                query: {
                  mid: data.mid, //对象转为字符串
                  city: data.city, //对象转为字符串
                  county: data.county, //对象转为字符串
                  province: data.province, //对象转为字符串
                },
              });
            } else {
              this.$toast(res.data.msg || "系统错误");
            }
          },
          (e) => {
            this.$toast("网络错误");
          }
        );
    },
    getList() {
      if (!this.key || this.isEnd) return;
      this.key = false;
      this.$http
        .post("Stafflist", {
          token: window.localStorage.getItem("token"),
          limit: 10,
          page: this.page,
        })
        .then(
          (res) => {
            this.key = true;
            if (res.data.code === 200) {
              let resData = res.data;
              this.list = [...this.list, ...resData.data.data];
              this.page++;
              this.isEnd = this.page * 10 >= +resData.data.total;
            } else {
              this.$toast(res.data.msg || "系统错误");
            }
          },
          (e) => {
            this.key = true;
            this.$toast("网络错误");
          }
        );
    },
    goDetail(obj) {
      if (obj) {
        this.$router.push({
          path: "/detail",
          query: {
            mid: obj.mid, //对象转为字符串
            city: obj.city, //对象转为字符串
            county: obj.county, //对象转为字符串
            province: obj.province, //对象转为字符串
          },
        });
      } else {
        this.$router.push("/detail");
      }
    },
    showPopup() {
      this.show = true;
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        for (let i = 0; i < 10; i++) {
          this.list.push(this.list.length + 1);
        }
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= 40) {
          this.finished = true;
        }
      }, 500);
    },
  },
};
</script>

<style lang="scss">
#app {
  background: #eeeeee;
}
.extension {
  .fn-box {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .fn-item {
      width: 2rem;
      height: 0.74rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 0.5rem;
      background: rgba(127, 207, 241, 1);
      color: #ffffff;
      font-size: 0.36rem;
    }
  }
  .van-cell {
    height: 0.88rem;
    border-bottom: 1px solid rgb(235, 237, 240);
  }
  .top-bg-st {
    position: relative;
    height: 2.4rem;
    width: 7.5rem;
    background-image: linear-gradient(to right, #038ed1, #1d208a);
    .top-bg-ss {
      position: absolute;
      top: 0.42rem;
      left: 0.32rem;
      right: 0.32rem;
      height: 3.8rem;
      background: #ffffff;
      border-radius: 0.32rem;
      .top-bg-ss-text {
        position: absolute;
        width: 2.8rem;
        height: auto;
        top: 0.64rem;
        right: 0.42rem;
      }
      .top-bg-ss-bg {
        position: absolute;
        width: 3.8rem;
        height: auto;
        bottom: 0.32rem;
        left: 0.32rem;
      }
    }
  }

  .search-clr-box {
    position: fixed;
    background: #ffffff;
    width: 6.86rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 5.38rem;
    height: 1.1rem;
    border-radius: 0.32rem;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      width: 6.2rem;
      height: 0.62rem;
      background: #eee;
      border-radius: 0.31rem;
      padding: 0 1.24rem 0 0.24rem;
      box-sizing: border-box;
      font-size: 0.28rem;
    }
    .search-icon {
      width: 0.58rem;
      height: 0.58rem;
      position: absolute;
      right: 0.6rem;
    }
  }

  .bottom-top-box {
    font-size: 0.28rem;
    position: fixed;
    background: #ffffff;
    width: 6.86rem;
    left: 0;
    right: 0;
    margin: 0 auto;
    top: 6.8rem;
    height: 0.84rem;
    border-top-right-radius: 0.32rem;
    border-top-left-radius: 0.32rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 0.32rem;
    box-sizing: border-box;
  }

  .list-box {
    position: fixed;
    background: #ffffff;
    border-bottom-right-radius: 0.32rem;
    border-bottom-left-radius: 0.32rem;
    top: 7.64rem;
    bottom: 0;
    width: 6.86rem;
    padding-bottom: 1.6rem;
    box-sizing: border-box;
    left: 0;
    right: 0;
    margin: 0 auto;
    overflow: auto;
  }

  .list-item {
    min-height: 1.2rem;
    border-bottom: 1px solid #ebedf0;
    padding-left: 0.12rem;
    color: #333333;
    font-size: 0.32rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .list-item-left {
      display: flex;
      flex-direction: column;
      .item-top {
        font-size: 0.28rem;
        margin-bottom: 0.08rem;
      }
      .item-bottom {
        font-size: 0.16rem;
      }
    }
    div {
      white-space: nowrap;
    }
  }
  .list-item-d {
    min-height: 1.2rem;
    border-bottom: 1px solid #ebedf0;
    padding-left: 0.12rem;
    color: #333333;
    font-size: 0.32rem;
    .list-item-left {
      display: flex;
      flex-direction: column;
      .item-top {
        font-size: 0.28rem;
        margin-bottom: 0.08rem;
      }
      .item-bottom {
        font-size: 0.16rem;
      }
    }
    div {
      white-space: nowrap;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/extension.vue